import React, { useContext } from 'react'
import MatchRecordingGroupsRow from '@Components/MatchComponents/MatchRecordingGroups/MatchingRecordingGroupsTable/MatchRecordingGroupsRow'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'

const MatchingRecordingGroupsTable = () => {
    const { matchingStore } = useContext(StoresContext)
    const recordingGroups = matchingStore.unmatchedSearchResults?.recordingGroups
    const selectedList = matchingStore.selectedUnmatchedRecordingGroups

    return (
        <>
            {recordingGroups?.map((recordingGroup) => (
                <MatchRecordingGroupsRow
                    key={`${recordingGroup.id}`}
                    result={recordingGroup}
                    selected={selectedList.includes(recordingGroup.id)}
                    deselect={matchingStore.deSelectUnmatchedRecordingGroup}
                    select={matchingStore.selectUnmatchedRecordingGroup}
                />
            ))}
        </>
    )
}

export default observer(MatchingRecordingGroupsTable)
